// Avatars DiceBear (adventurer) pour l'escape game "entreprise".
// - Centralise la liste + l'URL builder
// - Permet d'ajouter des "coups de cœur" (ex: seed=Aiden) facilement
// - L'ordre de la liste = l'ordre d'affichage (page 1 = plus probable)

// Nombre affiché par page (Play.js)
export const AVATARS_PER_PAGE = 10;

/**
 * Construit l'URL d'un avatar DiceBear.
 * On garde le fond uniforme pour ton UI.
 */
export function getAvatarUrl(seed) {
    if (!seed) return null;
    return `https://api.dicebear.com/9.x/adventurer/svg?seed=${encodeURIComponent(
        seed
    )}&backgroundType=solid&backgroundColor=111827`;
}

/**
 * ✅ Liste principale
 * - id: identifiant interne (doit être unique)
 * - label: label affiché dans la UI
 * - seed: seed DiceBear (ex: "Aiden")
 *
 * 👉 IMPORTANT :
 *   - L'ordre ici = l'ordre dans l'UI (page 1 = top picks)
 */
export const AVATARS = [
    // =========================
    // ⭐ TOP PICKS (page 1)
    // Mix diversité + vibe corporate/escape
    // =========================
    { id: "fav_aiden", label: "Consultante confiante", seed: "Aiden" },
    { id: "fav_brian", label: "Analyste reposé", seed: "Brian" },
    { id: "fav_aidan", label: "Designer optimiste", seed: "Aidan" },
    { id: "fav_nolan", label: "Développeuse audacieuse", seed: "Nolan" },
    { id: "analyst_7", label: "Ingénieure perspicace", seed: "analyst-determined-5" },
    { id: "vivian", label: "Cheffe de projet suspicieuse", seed: "Vivian" },
    { id: "fav_emery", label: "DevOps concentrée", seed: "Emery" },
    { id: "fav_liliana", label: "Directrice joyeuse", seed: "Liliana" },
    { id: "fav_easton", label: "Manager furtif", seed: "Easton" },
    { id: "hacker_6", label: "Ingénieur vigilant", seed: "hacker-mask-6" },
    // =========================
    // Page 2
    // =========================
    { id: "explorer_1", label: "Designer triste", seed: "hacker-focus-4" },
    { id: "explorer_2", label: "Consultante curieuse", seed: "explorer-calm-3" },
    { id: "explorer_3", label: "Product Owner imprévisible", seed: "explorer-clever-2" },
    { id: "explorer_4", label: "Ingénieure astucieuse", seed: "creative-dream-5" },
    { id: "explorer_5", label: "Analyste QA étonnée", seed: "engineer-serious-7" },
    { id: "explorer_6", label: "Employée espiègle", seed: "analyst-tired-4" },
    { id: "explorer_7", label: "Responsable IT calme", seed: "explorer-night-6" },
    { id: "explorer_8", label: "Auditrice stratégique", seed: "engineer-night-7" },
    { id: "explorer_9", label: "Manageuse intrépide", seed: "analyst-motivated-7" },
    { id: "hacker_1", label: "Coordinateur zen", seed: "hacker-chill-2" },
    // =========================
    // Page 3
    // =========================
    { id: "hacker_2", label: "Cheffe d'équipe motivée", seed: "hacker-night-2" },
    { id: "hacker_3", label: "Data scientist sceptique", seed: "hacker-sneaky-3" },
    { id: "hacker_4", label: "Ingénieure fatiguée", seed: "hacker-focus-8" },
    { id: "hacker_5", label: "Responsable innovation zen", seed: "hacker-analytic-7" },
    { id: "fav_sam", label: "Graphiste maline", seed: "Sam" },
    { id: "hacker_7", label: "Analyste agacé", seed: "hacker-ghost-7" },
    { id: "hacker_8", label: "Responsable RH méthodique", seed: "hacker-motivated-5" },
    { id: "analyst_1", label: "Manageuse déterminée", seed: "analyst-calm-1" },
    { id: "analyst_2", label: "DevOps curieuse", seed: "analyst-serious-2" },
    { id: "analyst_3", label: "Cheffe de projet résiliente", seed: "analyst-smile-3" },
    // =========================
    // Page 4
    // =========================
    { id: "analyst_4", label: "Analyste optimiste", seed: "analyst-focused-6" },
    { id: "analyst_5", label: "Consultante surprise", seed: "analyst-logic-5" },
    { id: "analyst_6", label: "Stagiaire motivé", seed: "analyst-curious-6" },
    { id: "fav_explorer_1", label: "Analyste QA maniaque", seed: "explorer-calm-1" },
    { id: "analyst_8", label: "Directrice coquette", seed: "analyst-serious-7" },
    { id: "engineer_1", label: "Ingénieur malin", seed: "engineer-calm-7" },
    { id: "engineer_2", label: "Technicien astucieux", seed: "engineer-focus-2" },
    { id: "engineer_3", label: "DevOps myope", seed: "engineer-smile-1" },
    { id: "engineer_4", label: "Manageuse malicieuse", seed: "engineer-serious-9" },
    { id: "engineer_5", label: "Graphiste méthodique", seed: "engineer-coffee-7" },
    // =========================
    // Page 5
    // =========================
    { id: "engineer_6", label: "Employé heureux", seed: "engineer-determined-6" },
    { id: "engineer_7", label: "Alternante joyeuse", seed: "engineer-night-7" },
    { id: "engineer_8", label: "Développeuse furtive", seed: "engineer-zen-8" },
    { id: "manager_1", label: "Lead Tech cafféiné", seed: "manager-calm-1" },
    { id: "manager_2", label: "Responsable RH curieuse", seed: "manager-motivator-2" },
    { id: "manager_3", label: "Cheffe de projet concentrée", seed: "manager-energy-3" },
    { id: "manager_4", label: "Analyste bienveillante", seed: "manager-kind-4" },
    { id: "manager_5", label: "Manageuse pragmatique", seed: "manager-hurry-5" },
    { id: "manager_6", label: "Collègue sympa", seed: "manager-nice-6" },
    { id: "manager_7", label: "Stagiaire épuisée", seed: "manager-diplomat-7" },
    // =========================
    // Page 6
    // =========================
    { id: "manager_8", label: "Alternant matinal", seed: "manager-strategy-8" },
    { id: "creative_1", label: "Manageur bienveillant", seed: "creative-color-1" },
    { id: "creative_2", label: "Ingénieure calme", seed: "creative-chill-2" },
    { id: "creative_3", label: "Technicien motivé", seed: "creative-idea-3" },
    { id: "creative_4", label: "Responsable RH zen", seed: "creative-dream-4" },
    { id: "creative_5", label: "Product Owner affamé", seed: "creative-weird-5" },
    { id: "creative_6", label: "Graphiste fatiguée", seed: "creative-pragmatic-6" },
    { id: "creative_7", label: "Consultant astucieux", seed: "creative-night-7" },
    { id: "creative_8", label: "Responsable IT méthodique", seed: "creative-minimal-8" },
    { id: "creative_9", label: "Développeur zen", seed: "creative-kind-2" },
];
